import { DiscountStatus as CommonDiscountStatus } from '@ekhodealer/ekho-common';

/**
 * Local types for discounts components
 * These types are copied from @ekhodealer/ekho-common until the PR is approved and the common repo is built
 */

/**
 * Discount status enum for the admin portal
 */
export enum DiscountStatus {
	ACTIVE = 'Active',
	SCHEDULED = 'Scheduled',
	EXPIRED = 'Expired',
}

/**
 * Discount method enum for the admin portal
 */
export enum DiscountMethod {
	CODE = 'Code',
	AUTOMATIC = 'Automatic',
}

/**
 * Discount type enum for the admin portal
 */
export enum DiscountType {
	AMOUNT_OFF_PRODUCTS = 'Amount off products',
	AMOUNT_OFF_ORDER = 'Amount off order',
	FREE_SHIPPING = 'Free shipping',
}

/**
 * Discount combination enum for the admin portal
 */
export enum DiscountCombination {
	ORDER = 'Order',
	SHIPPING = 'Shipping',
	PRODUCT = 'Product',
}

export interface DiscountHeader {
	name: string;
	amountOff?: string;
	minimum?: string;
	use?: string;
}

/**
 * DiscountName type - used for the name cell
 * Based on usage in the code, it's the same as DiscountHeader
 */
export type DiscountName = DiscountHeader;

export interface DiscountStatusInfo {
	value: DiscountStatus;
	startsAt: number;
	endsAt: number;
}

export interface DiscountsTableRow {
	id: string;
	name: DiscountHeader;
	status: DiscountStatusInfo;
	method: DiscountMethod;
	type: DiscountType;
	appliesTo: string;
	combinations: DiscountCombination[];
	used: number;
}

// Shared status → Tag accent mapping used by StatusCell and drawer header
export const DISCOUNT_STATUS_TAG_CONFIG: Record<
	string,
	{ label: string; accent: 'neutral' | 1 | 2 | 3 | 4 | 5 | 6 | 7 }
> = {
	[CommonDiscountStatus.ACTIVE]: { label: CommonDiscountStatus.ACTIVE, accent: 3 },
	[CommonDiscountStatus.SCHEDULED]: { label: CommonDiscountStatus.SCHEDULED, accent: 5 },
	[CommonDiscountStatus.EXPIRED]: { label: CommonDiscountStatus.EXPIRED, accent: 'neutral' },
};
